const ACTION_TYPES = {
	LIST: 'LIST',
	SELECT: 'SELECT',
	ADD: 'ADD',
	UPDATE: 'UPDATE',
	REMOVE: 'REMOVE',
	VIEW: 'VIEW'
};

const reducers = (state, action) => {
	switch (action.type) {
		case ACTION_TYPES.ALL: {
			return {
				...state,
				categories: action.data
			};
		}
		case ACTION_TYPES.LIST: {
			return {
				...state,
				rows: action.data.data,
				page: action.data.paginatorInfo.currentPage,
				perPage: action.data.paginatorInfo.perPage,
				total: action.data.paginatorInfo.total,
				currentPage: action.data.paginatorInfo.currentPage
			};
		}
		case ACTION_TYPES.ADD: {
			return {
				...state,
				rows: [...state.rows, action.data]
			};
		}
		case ACTION_TYPES.VIEW: {
			return {
				...state,
				category: action.data
			};
		}
		case ACTION_TYPES.UPDATE: {
			return {
				...state,
				categories:
					state?.categories?.length > 0
						? state.categories.map((item) =>
							item.id === action.data.category.id
								? action.data.category
								: item
						  )
						: [],
				rows:
					state?.rows?.length > 0
						? state.rows.map((item) =>
							item.id === action.data.category.id
								? action.data.category
								: item
						  )
						: []
			};
		}
		case ACTION_TYPES.REMOVE: {
			return {
				...state,
				rows: state?.rows?.filter(({ id }) => id !== action.id)
			};
		}
		default: {
			return state;
		}
	}
};

export { reducers, ACTION_TYPES };
